<template>
    <div>
        <div class="row mt-4 mb-3">
            <div class="col-12">
                <ejs-button class="btn btn-secondary w-100" v-on:click.native="onToggleFormsBasicData"
                            iconCss="btn-show" iconPosition="Right"
                            v-bind:class="{ 'btn-hide': toggleFormsBasicData }">DATOS BÁSICOS
                </ejs-button>
            </div>
        </div>
        <div v-if="toggleFormsBasicData">
            <form id="form-element" v-on:submit.prevent="validateBeforeSubmit">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label >{{ $t('textProcesses.textTitleState') }}:
                                    <span v-if="validStatus == 'Pendiente'" class="badge badge-warning">Pendiente</span>
                                    <span v-if="validStatus == 'Vencido'" class="badge badge-danger">Vencido</span>
                                    <span v-if="['Cumplido','Ejecutado'].includes(validStatus)" class="badge badge-success">Ejecutado</span>
                                    <span v-if="!listStatus.includes(validStatus) && validStatus != 'Cumplido'" class="badge badge-info">{{validStatus}}</span>
                                </label>
                                <a class="mx-1" id="editProcessButtonX"
                                v-if="rolLocal == 'Administrador'" title="Editar"
                                v-on:click="changeEditFunction"></a>
                                <ul class="list-group list-group-horizontal justify-content-start border-enable">
                                    <li v-if="validStatus == 'Pendiente' && ['RESPONSABLE','EQUIPO'].includes(profile)"
                                        class="list-group-item mr-4">
                                        <ejs-checkbox :change="onChangeRadioStatus" label="Ejecutado" value="Cumplido"
                                                    :checked="['Cumplido','Ejecutado'].includes(formData.status)" name="status"
                                                    cssClass='e-primary'></ejs-checkbox>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="compliance_date">Fecha de cumplimiento</label>
                                <ejs-textbox name="compliance_date" v-model="formData.compliance_date" placeholder="Fecha cumplimiento:"
                                            readonly="true"></ejs-textbox>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" >
                        <ejs-autocomplete :readonly=" !responsableFlag && rolLocal !== 'Administrador' || (responsableFlag && ['Cumplido','Ejecutado'].includes(formData.changeStatus)) " 
                            id="encargado" 
                            ref='encargado' 
                            name="encargado" 
                            v-model="formData.encargado" 
                            floatLabelType="Auto" 
                            :dataSource='dataSourceUsersTeamQuery' 
                            :fields='fieldsUsersTeamQuery' 
                            :showPopupButton='true' 
                            cssClass="e-outline" 
                            :placeholder="$t('gridHeaderText.textManager')" 
                            :data-required-message="$t('gridHeaderText.textErrorManager')" 
                            data-msg-containerid="encargadoError" 
                            suggestionCount="10000">
                        </ejs-autocomplete>
                        <div id="encargadoError" ref="encargadoError"></div>
                    </div>
                    <div class="form-group">
                        <hr>
                    </div>
                    <div class="form-group" v-show="btnEditstatus">
                        <label for="changeStatus">Cambio de estado</label>
                        <select name="changeStatus" id="changeStatus" class="form-control" v-model="formData.changeStatus"
                                required>
                            <option v-for="(item, index) in listStatus" v-bind:value="item" :key="index">{{ item }}</option>
                        </select>
                    </div>
                    <div class="form-group mb-0" v-show="btnEditstatus">
                        Relevancia: {{ formData.relevenceTmp }}
                    </div>
                    <div class="row border mr-0 ml-0 pt-2 " v-show="btnEditstatus">
                        <div class="col-lg-3 col-md-6" v-for="(relevence, index) in listRelevances" :key="index">
                            <input type="radio" name="relevancia" v-bind:id="'relevancia-'+relevence" v-bind:value="relevence"
                                v-bind:checked="relevence == formData.relevenceTmp" v-on:change="newRelevence(relevence)">
                            <label v-bind:for="'relevancia-'+relevence">{{ relevence }}</label>
                        </div>
                    </div>
                    <div class="form-group" v-show="btnEditstatus">
                        <label for="descriptionEdit">Descripción</label>
                        <textarea name="descriptionEdit" id="descriptionEdit" class="form-control"
                                v-model="formData.descriptionEdit" rows="4"></textarea>
                    </div>
                    <ejs-button type='submit' v-if="rolLocal == 'Administrador' || (validStatus == 'Pendiente' && ['RESPONSABLE','EQUIPO'].includes(profile)) || btnEditstatus == true"
                                :disabled="isSubmittingComplianceEdit"
                                cssClass="e-primary mt-3">{{ $t('textProcesses.textTitleUpdate') }}
                    </ejs-button> 
            </form>
        </div>
        <div class="row mt-4 mb-3">
            <div class="col-12">
                <ejs-button class="btn btn-secondary w-100" v-on:click.native="onToggleFormsObservations"
                            iconCss="btn-show" iconPosition="Right"
                            v-bind:class="{ 'btn-hide': toggleFormsObservations }">OBSERVACIONES
                </ejs-button>
            </div>
        </div>
        <form id="form-element-observations" v-on:submit.prevent="validateBeforeSubmitObservations">
            <div v-if="toggleFormsObservations">
                <div class="form-group">
                    <hr>
                </div>
                <ejs-grid ref='grid'
                          :dataSource='gridDataComplianceObservations'
                          :allowPaging="true"
                          :allowSorting="true"
                          :pageSettings='pageSettings'
                          :allowTextWrap='true'
                          :textWrapSettings="wrapSettings">
                    <e-columns>
                        <e-column field="responsable" :headerText="$t('gridHeaderText.user')" width="120px"
                                  textAlign="center" :template="templateResponsable"></e-column>
                        <e-column :template="date_created" :headerText="$t('gridHeaderText.date')" width="170px"
                                  textAlign="center"></e-column>
                        <e-column field="observacion" :headerText="$t('gridHeaderText.observations')"
                                  textAlign="left"></e-column>
                        <e-column :headerText="$t('gridHeaderText.support')" textAlign="center" width="150px"
                                  :template="templateComplianceSupport"></e-column>
                    </e-columns>
                </ejs-grid>
                <div class="form-group">
                    <hr>
                </div>
                <div class="form-group">
                    <ejs-datepicker name="observations_date" data-msg-containerid="formObservationsError1"
                                    v-model="formDataObservations.observations_date" :format="'yyyy-MM-dd'"
                                    :placeholder="'Fecha:'"></ejs-datepicker>
                    <div id="formObservationsError1"></div>
                </div>
                <div class="form-group">
                    <ejs-textbox name="observations_text" :multiline="true"
                                 data-msg-containerid="formObservationsError2"
                                 v-model="formDataObservations.observations_text"
                                 placeholder="Observación"></ejs-textbox>
                    <div id="formObservationsError2"></div>
                </div>
                <div class="form-group">
                    <label for="uploadFileObservationse">Documento</label>
                    <ejs-uploader
                        ref="uploadObjObservationse"
                        name="uploadFiles"
                        id="uploadFilesObservations"
                        :multiple='false'
                        :asyncSettings="uploaderSettings"
                        :uploading="addHeaders"
                        :removing="addHeaders"
                        :allowedExtensions="extensions"
                        :success="beforeUploadFilesObservations"></ejs-uploader>
                </div>
                <div class="form-group">
                    <ejs-button type='submit' cssClass="e-primary mt-3" :disabled="isSubmittingObservations">
                        {{ isSubmittingObservations ? 'Guardando...' : 'Guardar' }}
                    </ejs-button>
                </div>
            </div>
        </form>
        <div class="row mt-4 mb-3">
            <div class="col-12">
                <ejs-button class="btn btn-secondary w-100" v-on:click.native="onToggleFormsEvidences"
                            iconCss="btn-show" iconPosition="Right"
                            v-bind:class="{ 'btn-hide': toggleFormsEvidences }">EVIDENCIAS
                </ejs-button>
            </div>
        </div>
        <processes-detail-compliance-evidence-edit :data="data" :showEvidences="toggleFormsEvidences"></processes-detail-compliance-evidence-edit>
    </div>
</template>

<script>
import axios from 'axios'
import {DatePickerPlugin} from '@syncfusion/ej2-vue-calendars'
import { DialogUtility } from '@syncfusion/ej2-popups';

Vue.use(DatePickerPlugin)
export default {
    name: "processes-detail-compliance-edit",
    props: ["data"],
    components: {
        DialogUtility,
    },
    data: function () {
        return {
            fieldsUsersTeamQuery:{text:'user_name',value:'user_id'},
            profile: '',
            validStatus: '',
            validIsAdmin: 0,
            toggleFormsBasicData: true,
            toggleFormsEvidences: false,
            toggleFormsObservations: false,
            formObj: '',
            extensions: '.eml, .msg, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pst, .ost, .jpg, .png, .jpeg, .rar, .zip, .pdf',
            btnEditstatus: false,
            rolLocal: "",
            listStatus: ['Ejecutado', 'No Aplica', 'Pendiente', 'Vencido'],
            listRelevances: ['Baja', 'Media', 'Alta'],
            initialAttendad: null,
            formData: {
                statusComplianceId: 0,
                affairId: 0,
                compliance_date: new Date().toLocaleDateString("en-US"),
                external_link: '',
                status: 'Pendiente',
                encargado: null,
                pathFile: '',
                changeStatus: '',
                descriptionEdit: '',
                relevenceTmp: '',
                relevence: '',
            },
            formObjEvidences: '',
            formObjObservations: '',
            formDataObservations: {
                statusComplianceId: 0,
                observations_date: '',
                observations_text: '',
                pathFile: ''
            },
            options: {
                rules: {
                    'encargado': {
                        required: [true, "* Campo observación requerido."]
                    },
                }
            },
            optionsObservations: {
                rules: {
                    'observations_text': {
                        required: [true, "* Campo observación requerido."]
                    },
                    'observations_date': {
                        required: [true, "* Campo fecha requerido."],
                        date: [true, "* Campo fecha no valido."]
                    },
                }
            },
            uploaderSettings: {
                saveUrl: process.env.BASE_URL_FILE_SAVE,
                removeUrl: process.env.BASE_URL_FILE_REMOVE
            },
            templateResponsable: function (e) {
                return {
                    template: Vue.component('componentResponsable', {
                        template: `
                            <ejs-tooltip :content="data.responsable" ref="tooltip" :position="'TopCenter'">
                            <div class="e-avatar e-avatar-small e-avatar-circle">{{ $getInitials(data.responsable) }}
                            </div>
                            </ejs-tooltip>`,
                        data() {
                            return {
                                data: {},
                            };
                        },
                    })
                }
            },
            templateComplianceSupport: function (e) {
                return {
                    template: Vue.component('componentComplianceSupport', {
                        template: `
                            <div v-html="viewLinksSupport(data)"></div>`,
                        data() {
                            return {
                                data: {},
                            };
                        },
                        methods: {
                            viewLinksSupport: function (data) {
                                let response = "";
                                if (!!data.soporte) {
                                    let splitImage = data.soporte.split(/[\\$]/).pop(),
                                        extArr = data.soporte.split('.'),
                                        ext = extArr[extArr.length - 1].toLowerCase(),
                                        show = true,
                                        classDoc = '';

                                    if (ext === 'pdf')
                                        classDoc = "e-pdf-icon";
                                    else if (ext === 'jpg' || ext === 'png' || ext === 'jpeg' || ext === 'bmp')
                                        classDoc = "e-image-icon";
                                    else
                                        show = false;
                                    if (show) response += "<a class='mx-1 " + classDoc + "'href='" + process.env.BASE_URL_API_BACK + "viewFile/" + splitImage + "' target='_blank'></a>";
                                    response += "<a class='mx-1 e-download-icon' href='" + process.env.BASE_URL_API_BACK + "downloadFile/" + extArr[0] + "/" + extArr[1] + "' target='_self' download></a>";
                                }
                                if (response === "") {
                                    response += "-";
                                }
                                return response;
                            }
                        }
                    })
                }
            },
            date_created: function (e) {
                return {
                    template: Vue.component('templateButtons', {
                        template: `<span>{{ formatDate(data.created_at) }}</span>`,
                        data() {
                            return {
                                data: {}
                            };
                        },
                        methods: {
                            formatDate: function (date) {
                                let dateTmp = new Date(date);
                                //Fecha UTC -> Fecha LocangeRadioStatusl
                                let event = new Date(Date.UTC(dateTmp.getFullYear(), dateTmp.getMonth(), dateTmp.getDate(), dateTmp.getHours(), dateTmp.getMinutes(), 0, 0));
                                var options = {year: "numeric", month: "numeric", day: "numeric"};
                                return event.toLocaleString("es-ES", options) + ' ' + event.toLocaleTimeString();
                            }
                        },
                    })
                }
            },
            gridDataComplianceObservations: [],
            pageSettings: {pageSize: 25},
            wrapSettings: {wrapMode: 'Content'},
            responsableFlag: false,
            isSubmittingComplianceEdit: false,
            isSubmittingObservations: false
        }
    },
    mounted: function () {
        let localStor = this.$store.getters["moduleAvatar/avatar"];
        this.formObjObservations = new FormValidator('#form-element-observations', this.optionsObservations);
        this.formObjEvidences = new FormValidator('#form-element-evidences', this.optionsEvidences);
        /** Obtiene el Rol */
        this.rolLocal = localStor.role;

        /**Validación si la persona logeada es responsable del cumplimiento */
        let responsable = this.data.responsable.find(item => item.user_name.trim() == localStor.name.trim());
        this.responsableFlag = (responsable !== undefined && responsable.type == 'RESPONSABLE')? true : false;
        this.profile = (responsable !== undefined)? responsable.type : null;
        if(this.rolLocal == 'Administrador' || (this.responsableFlag && !['Cumplido','Ejecutado'].includes(this.formData.status))){
            this.formObj = new FormValidator('#form-element', this.options);
        }else{
            this.formObj = new FormValidator('#form-element', {});
        }
    },
    computed: {
        processesDetail() {
            return this.$store.state.moduleProcesses.dataProcessesDetail;
        },
        dataSourceUsersTeamQuery(){
            return this.data.responsable.filter(a => a.type != 'CONSULTA').sort(function sortArray(x,y){
                if (x.user_name < y.user_name) {return -1;}
                if (x.user_name > y.user_name) {return 1;}
                return 0;
            });
        }
    },
     watch: {
        processesDetail(newValue,oldValue){
            this.updateEvidences()
        }
    },
    methods: {
        updateEvidences: function(){
            this.gridDataComplianceEvidences = []
            var for_i = this.processesDetail.statusCompliance;
            for (let i = 0; i < for_i.length; i++) {
                for (let j = 0; j < for_i[i].compliance_status_evidence.length; j++) {

                    if (for_i[i].compliance_status_evidence[j].estado_cumplimiento_id == this.data.est_id) {
                        this.gridDataComplianceObservations = for_i[i].estado_cumplimiento_obs;
                        break;
                    }
                }
            }
        },
        addHeaders: function (args) {
            args.currentRequest.setRequestHeader('Authorization', `Bearer ${this.$store.state.moduleSession.token}`);
        },
        beforeUploadFiles: function (args) {
            var obj = JSON.parse(args.e.srcElement.response);
            this.formData.pathFile = obj.path;
        },
        beforeUploadFilesObservations: function (args) {
            var obj = JSON.parse(args.e.srcElement.response);
            this.formDataObservations.pathFile = obj.path;
        }, 
        initComplianceEdit: function () {
            let encargado = this.data.responsable.find(item => item.user_name == this.data.assing_to);
            this.validIsAdmin = this.$store.getters['moduleAvatar/avatar'].admin;
            this.validStatus = this.data.status;
            this.formData.changeStatus = this.data.status == "Cumplido" ? "Ejecutado" : this.data.status;
            this.formData.relevenceTmp = this.data.relevancia;
            this.formData.status = this.data.status;
            this.formData.affairId = this.data.asunto_id;
            this.formData.external_link = this.data.soporte;
            this.formData.statusComplianceId = this.data.est_id;
            this.formData.encargado = encargado ? encargado.user_id : null;
            if(['Cumplido','Ejecutado'].includes(this.data.status) && this.data.fecha_est != '') this.formData.compliance_date = this.data.fecha_est;
            this.formDataObservations.statusComplianceId = this.data.est_id;
            this.gridDataComplianceObservations = this.data.estado_cumplimiento_obs;
            this.data.index = this.processesDetail.statusCompliance.findIndex(item => item.est_id == this.data.est_id);
            
            this.initialAttendad = this.formData.encargado;
        },
        validateBeforeSubmit: function () {
            if (this.isSubmittingComplianceEdit) {
                return;
            }

            let formStatus = this.formObj.validate();
            if (formStatus) {
                this.isSubmittingComplianceEdit = true;
                let dialogObj = DialogUtility.confirm({
                    title: '¿Realmente deseas actualizar este registro?',
                    okButton: {  text: '¡Si, actualizar!', click: () => {
                        axios.post('/auth/processes/setComplianceEdit', {
                            data: this.formData,
                        }).then(response => {
                            this.$store.dispatch('moduleProcesses/actionsProcessesDetail', this.data.proceso_id);
                            this.formObj.element.reset();
                            dialogObj.hide();
                            Vue.prototype.$eventHub.$emit('closeSidebarClick');
                            Vue.prototype.$eventHub.$emit('showToastNotification', response.data);

                            this.updateLocalData();
                        }).catch(() => {
                        }).finally(() => {
                            this.isSubmittingComplianceEdit = false;
                        });
                    } },
                    cancelButton: {
                        text: '¡NO, salir!', click: () => {
                            this.isSubmittingComplianceEdit = false;
                            dialogObj.hide();
                        }
                    },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    close: () => {
                        this.isSubmittingComplianceEdit = false;
                    }
                });
            }
        },
        validateBeforeSubmitObservations: function () {
            if (this.isSubmittingObservations) {
                return;
            }

            let formStatus = this.formObjObservations.validate();
            if (formStatus) {
                this.isSubmittingObservations = true;
                axios.post('/auth/processes/setComplianceObservations', {
                    data: this.formDataObservations,
                }).then(response => {
                    this.$store.dispatch('moduleProcesses/actionsProcessesDetail', this.data.proceso_id).then(response => {
                        this.gridDataComplianceObservations = this.processesDetail.statusCompliance[this.data.index].estado_cumplimiento_obs;
                     });
                    this.formObjObservations.element.reset();
                    Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                }).catch(() => {
                }).finally(() => {
                    this.isSubmittingObservations = false;
                });
            }
        },
        onChangeRadioStatus: function (args) {
            this.formData.status = args.event.target.ej2_instances[0].value;
        },
        onToggleFormsObservations: function () {

            this.toggleFormsObservations = !this.toggleFormsObservations;
        },
        onToggleFormsBasicData: function () {
            this.toggleFormsBasicData = !this.toggleFormsBasicData;
        },
        onToggleFormsEvidences: function () {
            this.toggleFormsEvidences = !this.toggleFormsEvidences;
        },
        changeEditFunction: function () {
            this.btnEditstatus = !this.btnEditstatus;
        },
        newRelevence: function (relevence) {
            this.formData.relevence = relevence;
        },
        updateLocalData(){
            const eventName = 'processWasUpdated';
            
            if(this.formData.encargado != this.initialAttendad){
                var e = document.getElementById("encargado_hidden");
                var name = e.options[e.selectedIndex].text;
                let report = {"processId": this.formData.statusComplianceId, "type": "attendadChange", "name": name}
                
                Vue.prototype.$eventHub.$emit(eventName, report);
            }
            if(this.formData.changeStatus != this.formData.status){
                var newStatus = this.formData.changeStatus;
                let report = {"processId": this.formData.statusComplianceId, "type": "statusChange", "newStatus": newStatus}
                
                Vue.prototype.$eventHub.$emit(eventName, report);
            }
        }

    },
    created: function () {
        this.initComplianceEdit();
    }
}
</script>
<style>
#editProcessButtonX {
    padding: 0px;
    color: #222222;
    cursor: pointer;
}

#editProcessButtonX::before {
    content: '\e944';
    font-family: 'e-icons';
    font-size: 13px;
}
</style>
